export default __webpack_public_path__ + "static/media/icon-hat.d69140ea.svg";